// src/store/event/recommendedEvents.slice.ts
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getRecommendedEvents } from "apis/EventServiceApi";
import { RootState } from "store/types";

interface RecommendedState {
  data: Array<{
    id: number;
    activity_title: string;
    activity_description: string;
    image_url: string;
  }>;
  isLoading: boolean;
  error: string | null;
}

const initialState: RecommendedState = {
  data: [],
  isLoading: false,
  error: null,
};

export const fetchRecommendedEvents = createAsyncThunk(
  "recommendedEvents/fetchRecommendedEvents",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getRecommendedEvents();
      return response; // array
    } catch (error: any) {
      return rejectWithValue(
        error.message || "Error fetching recommended events"
      );
    }
  }
);

const recommendedEventsSlice = createSlice({
  name: "recommendedEvents",
  initialState,
  reducers: {
    resetRecommendedEvents: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecommendedEvents.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchRecommendedEvents.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.data = action.payload;
      })
      .addCase(fetchRecommendedEvents.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetRecommendedEvents } = recommendedEventsSlice.actions;
export default recommendedEventsSlice.reducer;

// Selector
export const selectRecommendedEvents = (state: RootState) =>
  state.recommendedEvents;
